import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Switch, Route, Link } from 'react-router-dom'

import { Box } from '@material-ui/core'
import QuickFeedLayout from '@scoir/components-core/dist/components/QuickFeedLayout'

import UpcomingVisitPreview from './UpcomingVisitPreview'
import RailHeading from './RailHeading'
import VisitHighSchoolFilter from './VisitHighSchoolFilter'
import MyCalendars from './MyCalendars'
import CalendarTypeFilters from './CalendarTypeFilters'

import { actions as upcomingVisitsActions } from 'store/upcoming-visits'

import './index.scss'

const generateViewAll = (target) => {
  return (
    <Switch>
      <Route
        path={target}
        exact
        render={() => null}
      />
      <Route render={() => <Link to={target}>View All</Link>} />
    </Switch>
  )
}

export class VisitsLayout extends React.Component {
  componentDidMount() {
    this.props.fetchUpcomingVisits(this.props.userId)
  }
  render() {
    return (
      <div className="calendar-layout-comp">
        <div className="rail">
          <div className="rail-comp highschool-filter">
            <VisitHighSchoolFilter />
          </div>
          <Box
            bgcolor="background.paper"
            borderRadius="borderRadius"
            className="rail-comp types"
          >
            <RailHeading>Visit Type</RailHeading>
            <CalendarTypeFilters />
          </Box>
          <Box
            bgcolor="background.paper"
            borderRadius="borderRadius"
            className="rail-comp my-cals"
          >
            <RailHeading>My Calendars</RailHeading>
            <MyCalendars />
          </Box>
          <Box
            bgcolor="background.paper"
            borderRadius="borderRadius"
            className="rail-comp upcoming"
          >
            <QuickFeedLayout
              headerComponent={
                <div className="upcoming-visits-header-wrapper">
                  <div>Upcoming Visits</div>
                  {generateViewAll(`${import.meta.env.BASE_URL}/recruit/visits/upcoming`)}
                </div>
              }
              headerBorderColor="#80c01c"
              collection={this.props.upcomingVisits || []}
              emptyCollectionText="No upcoming events are currently scheduled."
              itemComponent={UpcomingVisitPreview}
            ></QuickFeedLayout>
          </Box>
        </div>

        <div className="content">{this.props.children}</div>
      </div>
    )
  }
}

VisitsLayout.propTypes = {
  fetchUpcomingVisits: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  userId: PropTypes.string.isRequired,
  upcomingVisits: PropTypes.array,
}

export default connect(
  (state) => ({
    upcomingVisits: state.calendarUpcomingVisits,
    userId: state.user.record.Id,
  }),
  {
    fetchUpcomingVisits: upcomingVisitsActions.fetchUpcomingVisits,
  },
)(VisitsLayout)
